module.exports = __webpack_public_path__ + "static/media/workPvcCeilings8.e9bdfa05.jpg";